/**
 * BlurImage — V2.8.8 — click-to-reveal NSFW blur for user-uploaded chat images.
 * All inbound images render blurred by default; one tap removes the blur.
 * Lives next to GlobalChat / GuildChat / DM threads.
 */
import { useState } from "react";

export default function BlurImage({ src, alt = "", className = "" }) {
  const [revealed, setRevealed] = useState(false);
  return (
    <div className={`relative inline-block ${className}`} data-testid="blur-image">
      <img
        src={src}
        alt={alt}
        className={`max-w-full rounded border border-slate-800 transition-all duration-200 ${revealed ? "" : "blur-lg"}`}
        draggable={false}
      />
      {!revealed && (
        <button
          data-testid="blur-image-reveal"
          onClick={(e) => { e.preventDefault(); e.stopPropagation(); setRevealed(true); }}
          className="absolute inset-0 flex flex-col items-center justify-center bg-black/40 hover:bg-black/60 transition-colors rounded text-white">
          <i className="fa-solid fa-eye text-lg mb-1"/>
          <span className="text-[10px] font-bold uppercase tracking-wider">Tap to view</span>
        </button>
      )}
    </div>
  );
}
